import type TradingDataModel from '../models/tradingData.model'
import { type SubscribeToChannelResult, TradingDataWS } from "@trading/infrastructure";

export default class TradingDataService {
  constructor(private repo: TradingDataWS) {}

  async subscribeToChannel(
    instrument: string,
    interval: string,
    cb: (order: TradingDataModel) => void
  ): Promise<undefined | SubscribeToChannelResult> {
    console.log(`Subscribing to trading data channel for ${instrument} with interval ${interval}`)
    return await this.repo.subscribeToChannel(instrument, interval, cb)
  }
}
